module.exports = __webpack_public_path__ + "static/img/jianzhu07.93d0064.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Content/Friend/jianzhu07.png
// module id = 879m
// module chunks = 12